const Backbone = window.Backbone;
const url = window.url;
const routes = window.routes;
const windowText = window.text;
const featureManager = window.featureManager;

const isCanarySite = require('../../../../../../lib/utility/isCanarySite');

const TitleSeries = Backbone.View.extend({
    initialize({ hideSubtitle }) {
        this.useEnhancedSeries =
            featureManager.isEnabled('enhancedSeries') &&
            typeof this.model.get('detailedSeries') !== 'undefined';
        this.hideSubtitle = hideSubtitle;

        this.listenTo(this.model, 'update', this.render);
        this.render();
    },

    render() {
        let searchParams = this.useEnhancedSeries
            ? {
                  type: 'seriesId',
                  query: this.model.get('detailedSeries').seriesId,
                  sortBy: 'readingOrder',
              }
            : {
                  type: 'series',
                  query: this.model.get('series'),
                  sortBy: 'newlyadded',
              };

        let subtitleContainsSeries =
            this.model.get('subtitle') &&
            this.model.get('subtitle').indexOf(this.model.get('series')) > -1;

        let seriesText = '';
        let rankText = '';

        if (this.useEnhancedSeries) {
            let detailedSeries = this.model.get('detailedSeries');

            const readingOrder = detailedSeries.readingOrder;
            if (readingOrder) {
                seriesText = isNaN(readingOrder)
                    ? window.text('enhancedSeriesLinkText', { readingOrder })
                    : window.text('enhancedSeriesLinkNumber', { readingOrder });
            }

            const rank = detailedSeries.rank;
            if (rank) {
                rankText = window.text('rankText', { rank });
            }
        } else {
            seriesText = subtitleContainsSeries
                ? this.model.get('subtitle')
                : this.model.get('series') || '';
            rankText = subtitleContainsSeries
                ? this.model.get('subtitle')
                : this.model.get('rank') || '';
        }

        if (this.model.get('type').id === 'magazine') {
            searchParams.mediaType = 'magazine';
        }

        let viewModel = {
            id: this.model.get('id'),
            title: this.model.get('title'),
            series: seriesText,
            rank: rankText,
            subtitle: this.model.get('subtitle') || '',
            searchUrl: url(routes.searchByType, searchParams),
            language: _.first(this.model.get('languages') || ['']),
            noCreators: _.isEmpty(this.model.get('creators')),
        };

        let $temp = $(document.createDocumentFragment());

        if (
            !this.hideSubtitle &&
            !subtitleContainsSeries &&
            !_.isEmpty(viewModel.subtitle)
        ) {
            let $subtitle = this._buildSubtitle(
                viewModel.subtitle,
                viewModel.language
            );
            $temp.append($subtitle);
        }

        if (!_.isEmpty(viewModel.series)) {
            if (
                this.model.isMagazine &&
                featureManager.isEnabled('magazine-rollup')
            ) {
                let $series = this._buildSeriesText(
                    viewModel.noCreators,
                    viewModel.series
                );
                $temp.append($series);
            } else {
                let $series = this._buildSeriesLink(
                    viewModel.searchUrl,
                    viewModel.noCreators,
                    viewModel.series
                );
                $temp.append($series);
            }
        }

        if (
            !_.isEmpty(viewModel.rank) &&
            isCanarySite(window.OverDrive.tenant)
        ) {
            const $rank = this._buildRankText(
                viewModel.noCreators,
                viewModel.rank
            );
            $temp.append($rank);
        }

        this.$el.html($temp);
    },

    _buildRankText(noCreators, text) {
        return $('<p />', {
            class: `series ${(noCreators ? 'no-author' : '', text)}`,
            text,
        });
    },

    _buildSeriesText(noCreators, text) {
        let $elm = $('<p />', {
            class: `series ${(noCreators ? 'no-author' : '', text)}`,
        });
        return $elm;
    },

    _buildSeriesLink(searchUrl, noCreators, text) {
        let $elm = $('<p />', {
            class: `series ${noCreators ? 'no-author' : ''}`,
        });

        let $link = $('<a />', {
            'aria-label': windowText('cover.searchBySeries', { series: text }),
            class: this.useEnhancedSeries
                ? 'series-link-enhanced'
                : 'series-link',
            href: searchUrl,
            title: text,
            text,
        });

        $elm.append($link);

        return $elm;
    },

    _buildSubtitle(subtitle, language) {
        if (featureManager.isEnabled('fixHtmlTagsInCopy')) {
            return $(`<p class="subtitle" lang="${language}">${subtitle}</p>`);
        } else {
            return $('<p />', {
                class: 'subtitle',
                text: subtitle,
                lang: language,
            });
        }
    },
});

module.exports = TitleSeries;
